import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isString as _isString } from 'lodash';
import PropTypes from 'prop-types';

import {
  VFButton,
  VFText,
  PercentageIndicator,
  Icon,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeColors } from '../../../Themes';

import styles from './MyPlanUsageItem.Styles';

const MyPlanUsageItem = ({
  theme = LightThemeColors,
  icon,
  iconSize,

  percentageIndicatorFillColor,
  percentageIndicatorSecondaryColor,
  percentageIndicatorContainerStyle,
  percentageIndicatorShouldAnimate,
  usageItemLabel,
  usageItemLabelTextStyle,
  usageValuesText,
  usageValuesPlaceholders,
  usageValuesTextStyle,
  usagePercentageValue,
  usagePercentageTextStyle,
  isUnlimitedUsage,
  unlimitedUsageText,
  shouldShowAddUsageButton,
  addUsageButtonTitle,
  addUsageButtonHandler,
  addUsageButtonType,
  addUsageButtonTextStyle,
  usageButtonTestId,
  images,
  withUsagePercentage,
  containerStyle,
  usageItemLabelTestKey,
  usageValuesTextTestKey,
  usagePercentageValueTestKey,
}) => {
  const frameworkColors = getThemeColors(theme.name);
  return (
    <View style={[styles.containerStyle, containerStyle]}>
      <View style={styles.usageIconViewStyle(frameworkColors)}>
        <Icon name={images[icon]} type="image" size={iconSize > 30 ? 30 : iconSize} />
      </View>
      <View style={styles.usageDataViewStyle}>
        <View style={styles.usageValuesContainerViewStyle}>
          <View style={styles.usageItemLabelViewStyle}>
            <VFText
              style={[styles.usageItemLabelTextStyle, usageItemLabelTextStyle]}
              i18nKey={usageItemLabel}
              testKey={usageItemLabelTestKey}
            />
          </View>
          <View style={styles.usageValuesViewStyle}>
            {!isUnlimitedUsage && (
              <>
                <VFText
                  testKey={usageValuesTextTestKey}
                  style={[styles.usageValuesTextStyle(frameworkColors), usageValuesTextStyle, { color: usagePercentageValue > 25 ? '#007C92' : '#e60000' }]}
                  i18nKey={usageValuesText}
                  placeHolders={usageValuesPlaceholders}
                />
                {withUsagePercentage && (
                  <VFText
                    testKey={usagePercentageValueTestKey}
                    style={[styles.usagePercentageTextStyle(theme), usagePercentageTextStyle]}
                    i18nKey={'(' + usagePercentageValue + '%)'}
                  />
                )}
              </>
            )}
            {isUnlimitedUsage && (
              <VFText
                style={[styles.usageValuesTextStyle(frameworkColors), usageValuesTextStyle]}
                i18nKey={unlimitedUsageText}
              />
            )}
          </View>
        </View>
        <PercentageIndicator
          value={isUnlimitedUsage ? 100 : usagePercentageValue}
          isAnimated={percentageIndicatorShouldAnimate}
          fillColor={
            (_isString(percentageIndicatorFillColor) && percentageIndicatorFillColor) ||
            theme.colors.fillColor
          }
          color={
            usagePercentageValue > 25 ? '#007C92' : '#e60000'
          }
          containerStyle={[
            styles.percentageIndicatorContainerStyle,
            percentageIndicatorContainerStyle,
          ]}
        />
        {shouldShowAddUsageButton && (
          <VFButton
            testKey={usageButtonTestId}
            type={addUsageButtonType}
            title={addUsageButtonTitle}
            textStyle={[styles.addUsageButtonTextStyle, addUsageButtonTextStyle]}
            onPress={addUsageButtonHandler}
          />
        )}
      </View>
    </View>
  );
};
MyPlanUsageItem.defaultProps = {
  theme: LightThemeColors,
  iconSize: 26,
  percentageIndicatorShouldAnimate: false,
  usagePercentageValue: 100,
  isUnlimitedUsage: false,
  shouldShowAddUsageButton: false,
  addUsageButtonType: 'quaternary',
  withUsagePercentage: true,
};
MyPlanUsageItem.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  iconSize: PropTypes.number,
  images: PropTypes.object,
  percentageIndicatorFillColor: PropTypes.string,
  percentageIndicatorSecondaryColor: PropTypes.string,
  percentageIndicatorContainerStyle: ViewPropTypes.style,
  percentageIndicatorShouldAnimate: PropTypes.bool,
  usageItemLabel: PropTypes.string,
  usageItemLabelTextStyle: TextPropTypes.style,
  usageValuesText: PropTypes.string,
  usageValuesPlaceholders: PropTypes.arrayOf(PropTypes.any),
  usageValuesTextStyle: TextPropTypes.style,
  usagePercentageValue: PropTypes.number,
  usagePercentageTextStyle: TextPropTypes.style,
  isUnlimitedUsage: PropTypes.bool,
  unlimitedUsageText: PropTypes.string,
  shouldShowAddUsageButton: PropTypes.bool,
  addUsageButtonTitle: PropTypes.string,
  addUsageButtonHandler: PropTypes.func,
  addUsageButtonType: PropTypes.string,
  addUsageButtonTextStyle: TextPropTypes.style,
  containerStyle: ViewPropTypes.style,
  withUsagePercentage: PropTypes.bool,
  usageButtonTestId: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),

  usageItemLabelTestKey: PropTypes.string,
  usageValuesTextTestKey: PropTypes.string,
  usagePercentageValueTestKey: PropTypes.string,
};
export default withTheme(MyPlanUsageItem);
